export default "__VITE_ASSET__BglHT7fd__"